import { Pipe, PipeTransform } from '@angular/core';
import 'intl';
import 'intl/locale-data/jsonp/en.js';


@Pipe({
    name: 'distributorIdFormat'
})
export class DistributorIdFormatPipe implements PipeTransform {
    /**
   * @param  {string} distributorId
   */
    transform(input: string): string {
        if (!input) {
            return '';
        } else {
            return input.match(/.{1,3}/g).join('-');
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/distributor-id-format.pipe.ts